import { Dialog as DialogPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

export const DialogClose = (props: ComponentProps<typeof DialogPrimitive.Close>) => (
  <DialogPrimitive.Close data-slot="dialog-close" {...props} />
);
